import { useRef } from 'react';
import css from 'pages/Dev/RenderCount.module.scss';

export const RenderCount = ({ position = 'right' }: { position?: 'left' | 'right' }) => {
  const renders = useRef(0);
  const className = position === 'right' ? css.counter : `${css.counter} ${css.left}`;
  return <i className={className}>{++renders.current}</i>;
};
